import React, { useState } from "react";
import { Info } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

export default function CalcInfo({ title, children }) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          tabIndex={0}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          onFocus={() => setOpen(true)}
          onBlur={() => setOpen(false)}
          onClick={(e) => {
            // On touch devices there's no hover; let the click toggle.
            e.preventDefault();
            setOpen((v) => !v);
          }}
          className="inline-flex items-center justify-center w-6 h-6 rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 align-middle transition-colors dark:text-slate-500 dark:hover:text-slate-200 dark:hover:bg-slate-800"
          aria-label={title ? `Calculation info: ${title}` : "Calculation info"}
        >
          <Info className="w-3.5 h-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="start"
        className="text-sm w-64 leading-relaxed"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        {title && (
          <p className="font-semibold text-slate-900 mb-1 dark:text-slate-100">
            {title}
          </p>
        )}
        <div className="text-slate-600 dark:text-slate-300">{children}</div>
      </PopoverContent>
    </Popover>
  );
}